import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/main-menu.module.css";
import { Language, MainMenuItem, PageState } from "../types/index.js";
import { getMenuItems } from "../utils/utils.js";
import MainMenuListLeftNav from "./MainMenuListLeftNav.js";
import SmartLink from "./SmartLink.js";

interface Props {
  isPreview: boolean;
  languageId: Language;
  parentId: string;
  pages: PageState;
  currentMenuItem: MainMenuItem;
  menuLevel: number;
  activePagePath: string[];
  fallbackLanguageId: Language | undefined;
  onMenuItemClick: () => void;
}

const MainMenuLevelLeftNav: FunctionComponent<Props> = ({
  isPreview,
  languageId,
  parentId,
  pages,
  currentMenuItem,
  menuLevel,
  activePagePath,
  fallbackLanguageId,
  onMenuItemClick,
}) => {
  const menuItems = getMenuItems({
    pages,
    pageId: parentId,
    languageId,
    isPreview,
    fallbackLanguageId,
  });
  const { title, href, id, isFolder, target } = currentMenuItem;
  const isActive = activePagePath[0] === id;

  const listItemClassName = ClassNames(styles.MainMenu__ListItem, {
    [styles["MainMenu__ListItem--level1"]]: menuLevel === 1,
  });

  const linkItemClassName = ClassNames(styles.MainMenu__Item, {
    [styles["MainMenu__Item--level0"]]: menuLevel === 0,
    [styles["MainMenu__Item--level1"]]: menuLevel === 1,
    [styles["MainMenu__Item--level2up"]]: menuLevel >= 2,
    [styles["MainMenu__Item--active"]]: isActive,
  });

  const nextMenuLevel = menuLevel + 1;

  return (
    <li className={listItemClassName}>
      <div className={styles.MainMenu__ItemWrap}>
        <SmartLink
          isPreview={isPreview}
          anchorAttrs={{
            href: !isPreview && isFolder ? undefined : href,
            target,
            className: linkItemClassName,
            onClick: onMenuItemClick,
          }}
        >
          <span className={styles.MainMenu__Item__Text}>{title}</span>
        </SmartLink>
      </div>

      <MainMenuListLeftNav
        isPreview={isPreview}
        languageId={languageId}
        menuItems={menuItems}
        pages={pages}
        menuLevel={nextMenuLevel}
        activePagePath={activePagePath}
        fallbackLanguageId={fallbackLanguageId}
        onMenuItemClick={onMenuItemClick}
      />
    </li>
  );
};

export default MainMenuLevelLeftNav;
